//components
import {
  Section,
  Kicker,
  KickerDot,
  SectionTitle,
  SectionLede,
  Grad,
} from '@/containers-ai/SectionHeading';
import { Container } from '@/components/Grid';

//styles
import {
  Header,
  CardsGrid,
  AgentCard,
  CardTitle,
  CardDescription,
  CardReadMore,
} from './TheRestOfTheLineup.styles';

export function TheRestOfTheLineup({ cards }) {
  return (
    <Section id="lineup">
      <Container>
        <Header>
          <Kicker>
            <KickerDot />
            The rest of the lineup
          </Kicker>
          <SectionTitle style={{ maxWidth: 'none' }}>
            Eight more agents <Grad>running the same way.</Grad>
          </SectionTitle>
          <SectionLede style={{ maxWidth: '870px' }}>
            Loadsmart AI is nine specialized agents working the freight
            lifecycle end to end. If none of the nine match what is slowing
            your team down, describe the task and Loadsmart will build the
            agent to run it.
          </SectionLede>
        </Header>
        <CardsGrid>
          {cards.map((card) => (
            <AgentCard key={card.slug} href={`/ai/${card.slug}/`}>
              <div>
                <CardTitle>{card.title}</CardTitle>
                <CardDescription>{card.description}</CardDescription>
              </div>
              <CardReadMore>READ MORE &#8594;</CardReadMore>
            </AgentCard>
          ))}
        </CardsGrid>
      </Container>
    </Section>
  );
}
